import { render, staticRenderFns } from "./drag-and-match.vue?vue&type=template&id=afc5e0dc&scoped=true&"
import script from "./drag-and-match.vue?vue&type=script&lang=js&"
export * from "./drag-and-match.vue?vue&type=script&lang=js&"
import style0 from "./drag-and-match.vue?vue&type=style&index=0&id=afc5e0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc5e0dc",
  null
  
)

export default component.exports